import axios from "axios";
import authHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const getAll = async () => {
  return await axios.get(`${API_URL}/requirements`, {
    headers: authHeader(),
  });
};

const getAllById = async (id, origin = "observed") => {
  return await axios.get(`${API_URL}/requirements/${origin}/${id}`, {
    headers: authHeader(),
  });
};

const insert = (id, requirements) => {
  return axios
    .post(
      `${API_URL}/requirements/${id}`,
      { requirements },
      { headers: authHeader() }
    )
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

const updateOne = (id, vehicle_id, status) => {
  return axios
    .put(
      `${API_URL}/requirements/${id}/${vehicle_id}/${status}`,
      {},
      { headers: authHeader() }
    )
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

const updateAll = (id) => {
  return axios
    .patch(`${API_URL}/requirements/${id}`, {}, { headers: authHeader() })
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      throw new Error(response.data.message);
    });
};

export default {
  getAll,
  getAllById,
  insert,
  updateOne,
  updateAll,
};
